import { Link } from 'react-router-dom';

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--paper)]">
      <header className="border-b border-[var(--border)] bg-[var(--surface)]">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" aria-label="Bootcamp Institute · verify">
            <img
              src="/logo-bootcamp-institute.png"
              alt="Bootcamp Institute"
              height={28}
              className="h-7 w-auto transition-opacity duration-200 group-hover:opacity-80"
              decoding="async"
            />
            <span
              className="hidden sm:inline text-[11px] uppercase tracking-[0.18em] text-[var(--bi-claro)] border-l border-[var(--border)] pl-3"
              aria-hidden
            >
              verify
            </span>
          </Link>
          <nav className="text-[13px]">
            <Link
              to="/about"
              className="text-[var(--bi-oscuro)] hover:text-[var(--bi-energico)] transition-colors"
            >
              Cómo funciona
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-[var(--border)] mt-20">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10 grid grid-cols-1 sm:grid-cols-3 gap-8 text-[12px] text-[var(--bi-claro)]">
          <div>
            <img
              src="/logo-bootcamp-institute.png"
              alt="Bootcamp Institute"
              height={20}
              className="h-5 w-auto opacity-70 mb-3"
              decoding="async"
            />
            <p className="leading-relaxed">
              Sistema institucional de credenciales verificables, emitidas bajo el estándar{' '}
              <a className="text-[var(--bi-oscuro)] hover:text-[var(--bi-primario)] underline-offset-2 hover:underline" target="_blank" rel="noopener noreferrer" href="https://www.imsglobal.org/Badges/OBv2p0/index.html">Open Badges 2.0</a>.
            </p>
          </div>
          <div>
            <p className="eyebrow">Verificación programática</p>
            <pre className="mt-2 text-[10px] leading-relaxed text-[var(--bi-oscuro)] font-mono whitespace-pre-wrap break-all">
GET /api/v1/verify/{'{code}'}{'\n'}Accept: application/ld+json
            </pre>
          </div>
          <div>
            <p className="eyebrow">Contacto</p>
            <ul className="mt-2 space-y-1">
              <li><a className="hover:text-[var(--bi-oscuro)]" href="mailto:verify@bootcamp-institutex.com">verify@bootcamp-institutex.com</a></li>
              <li><a className="hover:text-[var(--bi-oscuro)]" href="https://bootcamp.institute" target="_blank" rel="noopener noreferrer">bootcamp.institute →</a></li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}
